import React, { useCallback, useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';

import * as Core from '../../../core';
import withLoading, { WithLoadingProps } from '../../../components/withLoading';
import history from '../../../services/history';
import { SeasonService } from '../../../services/seasonService';
import EditSeason from '../editSeason';

import './seasonSettingsPage.scss';

interface SeasonSettingsPageRouteProps {
    seasonId: string;
}

interface SeasonSettingsPageProps extends WithLoadingProps, RouteComponentProps<SeasonSettingsPageRouteProps> {}

const SeasonSettingsPage = (props: SeasonSettingsPageProps) => {
    const {
        match: {
            params: { seasonId },
        },
        setError,
        setIsLoading,
    } = props;
    const [currentSeason, setCurrentSeason] = useState<Core.Models.Season | undefined>(undefined);

    const reloadSeason = useCallback(async () => {
        const response = await SeasonService.getById(seasonId);
        setCurrentSeason(response);
    }, [seasonId]);

    useEffect(() => {
        (async () => {
            try {
                await reloadSeason();
            } catch (e) {
                setError(e);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [reloadSeason, setError, setIsLoading]);

    if (!currentSeason) return <></>;

    const heroUrl = Core.Competition.seasonHeroUrl(currentSeason);

    return (
        <>
            <div className="season-page-image" style={heroUrl ? { backgroundImage: `url("${heroUrl}")` } : undefined}>
                <div className="season-page-image-gradiant" />
            </div>
            <div className="season-page-form global-container-centered global-container-centered--wide">
                <EditSeason
                    season={currentSeason}
                    seasonId={seasonId}
                    onImagesChanged={reloadSeason}
                    onComplete={async () => {
                        history.push(`/seasons/${seasonId}`);
                    }}
                />
            </div>
        </>
    );
};

export default withLoading(SeasonSettingsPage, {
    errorDisplayPageProps: { fullPage: true },
    isLoadingByDefault: false,
    loadingProps: { blockItem: true },
    showNotFoundFor404: true,
});
